import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
    :root{
        --maxWidth: 1280px;
        --navBarHeight: 60px;
        --background: #fff;
        --backgroundActiveLi: rgba(255,255,255,0.25);
        --black: #000;
        --blackOverlay: rgba(0,0,0,0.75);
        --fontColor: #000;
        --textColor: var(--fontColor);
        --defaultFont: 'Raleway', sans-serif;
        --defOutline: 1px solid #000;
        --cardWidth: 350px; //hexagon
        --cardHeight: 350px;
        --fontSmall: 11px;
        --fontMedium: 1.1em;
        --buttonGrey: #DFDFDF;
        --lightestGrey: #F2F2F2;
        --lighterGrey: #DDDDDD;
        --lightGrey: #CCCCCC;
        --grey: #9C9C9C;
        --lightBlue: #bff5fd;
        --goldSolid: rgb(252, 216, 88);
        --goldShadowCentered: 0 0 10px 0 var(--goldSolid);
        --gold80: rgba(252, 216, 88, .8);
        --headerHeight: 60px;
        --inputBorder: 1px solid var(--fontColor);
        --fontBig: 1.5em;
        --buttonBackground: #fff;
        --buttonDisabledBgd: var(--lightestGrey);
        --buttonDisabledBorder: 2px solid var(--grey);
        --buttonDisabledText: var(--grey);
        --buttonBorderRadius: 5px;
        --buttonBorder: 2px solid #000;
        --buttonLetterSpacing: 0.15rem;
        --buttonFontWeight: 700;
        --buttonFontColor: #000;
        --buttonFontSize: 11px;
        --buttonHeight: 56px;
        --purpleGrey: #696980;
        --red: #C1272D;
        --defaultInputHeight: 49px;
        --badgeSize: 37px;
        --artworkCardWidth: 200px; // general cards
        --artworkCardHeight: 350px;
        --artworkCardImageSize: 200px;
        --artworkCardArtistFontSize: 10px;
        --artworkCardArtistFontWeight: 600;
        --letterSpacingCommon: 0.02rem;
        --artworkCardTitleFontSize: 13px;
        --artworkCardTitleFontWeight: 400;
        --goldGradient: -webkit-linear-gradient( 90deg,
        #FBC926, #FFF5B7, #C3922E, #EED688, #FFFBCC, #FEED9E, #FCD243 );
        --progressBarGradient: -webkit-linear-gradient( 0deg, #000000, #857AFF );
        --formBackground: #ffffff;
        --uiollyPurple: #857AFF;
        --alphaPurple: rgba(133,122,255,0.25);
        --primary: var(--fontColor);
        --secondary: var(--grey);
        --bold: 500;
        --boldSmall: 600;
        --boldSmallLetterSpacing: 0.07rem;
    }

    * {
        box-sizing: border-box;
        font-family: 'Poppins', sans-serif;
    }

    body{
        margin: 0;
        padding: 0;
        background: var(--background);
        color: var(--fontColor);
        overflow-x: hidden;
        width: 100%;
    }
    html{
        margin: 0;
        width: 100%;
            font-size: 15px;
            font-family: 'Poppins';
            h1{
                text-align: center;
            user-select: none;
            /* margin: 0; */
            font-size: 2.5em;
            line-height: 2.2rem;
            font-weight: 500;
            /* letter-spacing: 0.02rem; */
            /* margin-bottom: 25px; */
        }
        h2{
            user-select: none;
            font-size: 2em;
            line-height: 2.2rem;
            font-weight: 200;
            letter-spacing: 0.03rem;
        }
        h3{
            user-select: none;
            font-size: 1.5em;
            line-height: 1.5rem;
            font-weight: 600;
            letter-spacing: 0.03rem;
        }
        h4{
            font-weight: var(--boldSmall);
            font-size: .9em;
            line-height: 1.2rem;
            letter-spacing: 0.07rem;
            margin: 0;
            text-transform: uppercase; 
            /* font-weight: var(--bold);
font-size: 16px;
line-height: 1.2rem;
letter-spacing: 0.07rem;
text-transform: uppercase; */
        }
        p{
            font-weight: 300;
            
        }
        a{
            display: flex;
            text-decoration: none;
            color: var(--fontColor);
        }
    }
    @media screen and (min-width:768px) {
    html {
        font-size: 16px;
    }
    }

    @media screen and (min-width:1024px) {
    html {
        font-size: 16px;
    }
    }

    @media screen and (min-width:1300px) {
    html {
        font-size: 18px;
    }
}
`;